export { RatingFacet } from './RatingFacet';
export type { RatingFacetProps } from './RatingFacet.types';
